import React from 'react';

import Calculator from './components/Calculator/Calculator.component';

import './styles/main.scss';

class App extends React.Component {

  render() {
    return (
      <Calculator />
    )
  }
}

export default App;
